export const customStyles = {
    option: (styles, state) => ({
        ...styles,
        cursor: "pointer"
    }),
    control: styles => ({
        ...styles,
        cursor: "pointer"
    })
};